import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { appConfig, isOktaConfigured } from "../config/appConfig";

const isLocalStorageAvailable = () => {
  try {
    const test = "__localStorage_test__";
    window.localStorage.setItem(test, test);
    window.localStorage.removeItem(test);
    return true;
  } catch {
    return false;
  }
};

const OktaConfiguration = ({ children }) => {
  const navigate = useNavigate();

  const oktaAuth = useMemo(() => {
    if (!isOktaConfigured) {
      return null;
    }

    const storageAvailable = isLocalStorageAvailable();

    return new OktaAuth({
      issuer: appConfig.oktaIssuer,
      clientId: appConfig.oktaClientId,
      redirectUri: `${window.location.origin}${appConfig.oktaLoginCallbackPath}`,
      postLogoutRedirectUri: `${window.location.origin}${appConfig.oktaLogoutCallbackPath}`,
      pkce: true,
      scopes: appConfig.oktaScopes,
      storageManager: storageAvailable
        ? undefined
        : {
            getItem: (key) => sessionStorage.getItem(key),
            setItem: (key, value) => sessionStorage.setItem(key, value),
            removeItem: (key) => sessionStorage.removeItem(key),
          },
    });
  }, []);

  if (!oktaAuth) {
    return children;
  }

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || "/", window.location.origin), { replace: true });
  };

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

export default OktaConfiguration;
